import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ClickAwayListener from 'react-click-away-listener';

import { ReactComponent as Filter } from '../../assets/icons/filter.svg';
import { DATE_OPTIONS, STATUSES } from '../../config';
import { Button, DropdownMenu, FormInput } from '../';
import { TableExportData } from '.';

const ClearIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path d="m3.5 3.5 7 7m0-7-7 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const TableFilters = ({
  dataToExport,
  onSearch,
  searchPlaceholder,
  onClear,
  onStatusChange,
  onDateFilter,
  filter,
  exportUrl,
  ...props
}) => {
  const [showStatusFilters, setShowFilters] = useState(false);
  const [showDateFilters, setShowDateFilters] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [selected, setSelected] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  // The in-field clear (×) is opt-in: only when a parent passes `onClear` does
  // the search become controlled so the × can empty it. Without it the input
  // stays exactly as before, so other tables are untouched.
  const clearable = typeof onClear === 'function';
  const [searchText, setSearchText] = useState('');

  const filters = STATUSES[filter];

  const handleSearch = (e) => {
    if (e.key === 'Enter') {
      onSearch(e.target.value);
    } else if (e.target.value.length <= 1 && e.key === 'Backspace') {
      onSearch('');
    }
  };

  const handleClear = () => {
    setSearchText('');
    onClear();
  };
  const handleSelect = (e, label) => {
    setShowFilters(false);
    if (label === selected) {
      setSelected('');
      onStatusChange('');
    } else {
      let stat = filters.find((item) => label === item.label);
      setSelected(label);
      onStatusChange(stat.value);
    }
  };
  const handleSelectDate = (e, label) => {
    setShowDateFilters(false);
    if (label === selectedDate) {
      setSelectedDate('');
      onDateFilter('');
    } else {
      let date = DATE_OPTIONS.find((item) => label === item.label);
      setSelectedDate(label);
      onDateFilter(date.value);
    }
  };
  return (
    <div className="table__filters" {...props}>
      <div className="table__search">
        <FormInput
          placeholder={
            searchPlaceholder
              ? searchPlaceholder
              : 'Search for customer email, description, currency or reference ID'
          }
          name="search"
          type="search"
          value={clearable ? searchText : undefined}
          onChange={clearable ? (e) => setSearchText(e.target.value) : undefined}
          onKeyUp={handleSearch}
          onBlur={handleSearch}
        />
        {clearable && searchText && (
          <button
            type="button"
            className="table__search-clear"
            aria-label="Clear search"
            onClick={handleClear}
          >
            <ClearIcon />
          </button>
        )}
      </div>
      <div className="table__actions">
        {onStatusChange && (
          <Button variant="white" size="small" onClick={() => setShowFilters(!showStatusFilters)}>
            <Filter />
            Filter by {filter} status
            <ClickAwayListener
              onClickAway={() => showStatusFilters && setShowFilters(!showStatusFilters)}
            >
              <DropdownMenu
                open={showStatusFilters}
                options={filters}
                name="Filter by transactions"
                selected={selected}
                handleSelect={handleSelect}
                isFilter
              />
            </ClickAwayListener>
          </Button>
        )}
        {onDateFilter && (
          <Button variant="white" size="small" onClick={() => setShowDateFilters(!showDateFilters)}>
            <Filter />
            Filter by date
            <ClickAwayListener
              onClickAway={() => showDateFilters && setShowDateFilters(!showDateFilters)}
            >
              <DropdownMenu
                open={showDateFilters}
                options={DATE_OPTIONS}
                name="Filter by date"
                selected={selectedDate}
                handleSelect={handleSelectDate}
                isFilter
              />
            </ClickAwayListener>
          </Button>
        )}
        {props.addon}
        {dataToExport && (
          <Button variant="primary" size="small" onClick={() => setShowExportModal(true)}>
            Export CSV
          </Button>
        )}
      </div>
      {showExportModal && (
        <TableExportData
          dataToExport={dataToExport}
          exportUrl={exportUrl}
          closeModal={() => setShowExportModal(false)}
        />
      )}
    </div>
  );
};

TableFilters.propTypes = {
  dataToExport: PropTypes.string,
  onSearch: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  onClear: PropTypes.func,
  onStatusChange: PropTypes.func,
  onDateFilter: PropTypes.func,
  filter: PropTypes.string,
  addon: PropTypes.element
};
export { TableFilters };
